import React,{useEffect} from "react";
import { useDispatch, useSelector } from "react-redux";
import {getMapMyIndiaAccessToken} from '../Redux/Actions'
import axios from "axios";

function Location() {

    const dispatch = useDispatch()
    const mapToken = useSelector((state) => state.mapMyindiaToken);

    console.log(mapToken,"token here")
    useEffect(() =>{
        const userFromLocal = JSON.parse(localStorage.getItem("user"));
        var token = userFromLocal.token;
        dispatch(getMapMyIndiaAccessToken(token))
    },[])

  const locationAutoCompleteSearch = (e) => {
    if(!mapToken.loading && e.target.value?.length > 2){
    const urlForMap = `https://atlas.mapmyindia.com/api/places/search/json?query=${e.target.value}&access_token=${mapToken.accesstoken}&tokenizeAddress=true`;
    axios.get(urlForMap).then((res)=>{
        res.data.suggestedLocations.map((item)=>{
            console.log(item.placeAddress) 
        })
    }).catch((err)=>{
        console.log(err)
    })
    // console.log(e.target.value,data,"Here is value")
    }
  }

  return (
    <div>
        <input
          type="text" 
          onChange={locationAutoCompleteSearch}
        />
    </div>
  );
}

export default {
  component: Location,
};
